export const DAO_CODE = 'NOTIFICATION' + '_DAO';
